import * as React from "react";
import cx from "clsx";
import { TYPES } from "../../consts";
const Edge = ({
  type,
  d
}) => {
  return /*#__PURE__*/React.createElement("path", {
    className: cx(type === TYPES.LEGROOM && "fill-blue-light-active", type === TYPES.DEFAULT && "fill-product-light-active", type === TYPES.UNAVAILABLE && "fill-cloud-light-active"),
    d: d
  });
};
export default Edge;